module.exports = __webpack_public_path__ + "static/media/Week1.601df5ff.pdf";